/**
 * Colore automatico del cliente derivato dall'id, quindi sempre lo stesso per quel cliente.
 * L'angolo aureo (137.508°) distribuisce bene id consecutivi e due livelli di
 * saturazione/luminosità aumentano la separazione. Può capitare che due clienti abbiano
 * colori simili: per questo si può scegliere un colore a mano (`coloreScelto`).
 */
export const clienteColorAuto = (id: number | null | undefined): string | undefined => {
    if (id == null) return undefined;
    const hue = Math.round((id * 137.508) % 360);
    const ring = id % 2;
    const sat = ring === 0 ? 72 : 58;
    const light = ring === 0 ? 45 : 38;
    return `hsl(${hue}, ${sat}%, ${light}%)`;
};

/** Colore scelto se valido (#rrggbb), altrimenti quello automatico. */
export const clienteColor = (id: number | null | undefined, coloreScelto?: string | null): string | undefined =>
    coloreScelto && /^#[0-9a-fA-F]{6}$/.test(coloreScelto) ? coloreScelto : clienteColorAuto(id);
